import { render, staticRenderFns } from "./AssetHistoricalMetrics.vue?vue&type=template&id=bdb63d4e&"
import script from "./AssetHistoricalMetrics.vue?vue&type=script&lang=ts&"
export * from "./AssetHistoricalMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports